import {
  Button,
  Divider,
  Drawer,
  Form,
  Input,
  Select,
  Space,
  Tooltip,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useClient } from "../../Context/ClientContext";
import { notificationContext } from "../../Common/Routing/PageRoute";
import OrganisationsService, {
  Department_Type,
  DepartmentTypeList,
  IDepartmentOptionsList,
  IDepttRequestModel,
  ISubUnitOptionsList,
} from "../../Services/Organisations/OrganisationsService";
import { IApiResponse } from "../../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "../../Services/ItemsService";
import { IDropdownProps } from "../Settings/VoucherTemplate/SettingVoucherTemplate";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useHotkey } from "../../Context/HotKeyContext";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import { IDrawerModel, IOrganisationDetails } from "../../../Types";
import AddOrganisationModel from "./AddOrganisationModel";
import AddSubUnitModel from "./AddSubUnitModel";
import { suspend } from "@hookstate/core";

const AddDepttModel = ({
  isModalOpen,
  setOpenModel,
  id,
  setTrigger,
  setNewDepartmentResponse,
  placement,
  organisationId,
  organisationName,
  subUnitId,
  subUnitName,
}: IOrganisationDetails) => {
  const { showKeys } = useHotkey();
  const [form] = Form.useForm();
  const { currentClient } = useClient();
  const [loading, setLoading] = useState<boolean>(false);
  const { openNotification } = useContext(notificationContext);
  const [orgList, setOrgList] = useState<IIdNameModel[]>([]);
  const [selOrg, setSelOrg] = useState<{ id: string; name: string }>({
    id: "",
    name: "",
  });
  const [subUnitList, setSubUnitList] = useState<ISubUnitOptionsList[]>([]);
  const [allDeptName, setAllDeptName] = useState<string[]>([]);
  const [duplicateData, setDuplicateData] = useState<boolean>(false);
  const [newOrganisationResponse, setNewOrganisationResponse] =
    useState<IIdNameModel>({ id: "", name: "" });
  // Post Api
  const [newSubUnitResponse, setNewSubUnitResponse] =
    useState<ISubUnitOptionsList>({ id: "", name: "", orgId: "" });
  const [openModelType, setOpenModelType] = useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });

  const saveData = () => {
    form.validateFields().then(async (val) => {
      let newVal = {
        ...val,
        depttName: val.depttName.trim(),
        orgId: val.orgId?.value,
        subUnitId: val.subUnitId?.value,
      };

      setLoading(true);
      await OrganisationsService.postDepartment(currentClient?.id!, newVal, id!)
        .then((val: IApiResponse<IIdNameModel>) => {
          if (val.result) {
            openNotification(
              "success",
              `${val?.result?.name} department ${
                id ? "updated" : "added"
              } successfully`
            );
            setOpenModel({
              type: "",
              param: {},
            });
            setNewDepartmentResponse &&
              setNewDepartmentResponse({
                ...val.result,
                subUnitId: subUnitId!,
              });
            setLoading(false);
            setTrigger && setTrigger((prev) => !prev);
          } else {
            setLoading(false);
            openNotification("error", val.message);
          }
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    });
  };

  useEffect(() => {
    (async () => {
      await OrganisationsService.getDepartmentOptionsList(
        currentClient?.id!
      ).then((data: IDepartmentOptionsList[] | null) => {
        setAllDeptName(data!.map((each: IDepartmentOptionsList) => each.name));
      });
    })();
  }, []);

  // useEffect(() => {
  //   getOrgList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentClient?.id]);
  console.log("subUnitList", subUnitList);
  const getData = async () => {
    setLoading(true);
    await OrganisationsService.getDepartment(currentClient?.id!, id!)
      .then((val: IDepttRequestModel | null) => {
        let formValues = {
          depttName: val?.depttName,
          orgId: { value: val?.orgId, label: val?.orgName },
          subUnitId: { value: val?.subUnitId, label: val?.subUnitName },
          depttType: val?.depttType,
        };

        form.setFieldsValue(formValues);
        setSelOrg({ id: val?.orgId!, name: val?.orgName! });
        setLoading(false);
      })
      .catch((er) => {
        console.log("Data fetching error: ", er.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (id) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleDuplicates = (deptName: string) => {
    let filteredData = allDeptName.filter(
      (e) => e.toLowerCase().trim() === deptName.toLowerCase().trim()
    );
    if (filteredData.length > 0) setDuplicateData(true);
    else setDuplicateData(false);
  };
  //-----Added New Organization Data -----------//
  useEffect(() => {
    if (newOrganisationResponse.id.length > 0) {
      setOrgList((pre: IIdNameModel[]) => {
        let newData = [...pre, newOrganisationResponse];
        return newData;
      });
      setSelOrg({
        id: newOrganisationResponse?.id,
        name: newOrganisationResponse?.name,
      });
    }
  }, [newOrganisationResponse]);

  //----- newly added organisation data placing in form ----------//
  useEffect(() => {
    let exist = orgList.some(
      (e: IIdNameModel) => e.id === newOrganisationResponse.id
    );
    if (exist) {
      form.setFieldValue("orgId", {
        key: newOrganisationResponse.id,
        value: newOrganisationResponse.id,
        label: newOrganisationResponse.name,
        title: "",
      });
      form.setFieldValue("subUnitId", undefined);
    }
  }, [orgList]);

  useEffect(() => {
    if (newSubUnitResponse.id.length > 0) {
      setSubUnitList((pre: ISubUnitOptionsList[]) => {
        let newData = [...pre, newSubUnitResponse];
        return newData;
      });
    }
  }, [newSubUnitResponse]);

  //----- newly added sub unit data data placing in form ----------//
  useEffect(() => {
    console.log("newSubUnitResponse", newSubUnitResponse);
    let exist = subUnitList.some(
      (e: ISubUnitOptionsList) => e.id === newSubUnitResponse.id
    );
    if (exist)
      form.setFieldValue("subUnitId", {
        key: newSubUnitResponse.id,
        value: newSubUnitResponse.id,
        label: newSubUnitResponse.name,
        title: "",
      });
  }, [subUnitList]);

  const getOrgList = async () => {
    if (organisationId && organisationName) {
      form.setFieldValue("orgId", {
        key: organisationId,
        value: organisationId,
        label: organisationName,
        title: "",
      });
      setSelOrg({ id: organisationId, name: organisationName });
    } else {
      setLoading(true);
      await OrganisationsService.getOrgOptionsList(currentClient?.id!)
        .then((val) => {
          if (val) {
            setOrgList(val);
          }
          setLoading(false);
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    }
  };

  const getSubUnitList = async () => {
    if (subUnitId) {
      form.setFieldValue("subUnitId", {
        key: subUnitId,
        value: subUnitId,
        label: subUnitName,
        title: "",
      });
    } else {
      setLoading(true);
      await OrganisationsService.getSubUnitOptionsList(currentClient?.id!)
        .then((val) => {
          if (val) {
            setSubUnitList(val);
          }
          setLoading(false);
        })
        .catch((er) => {
          console.log("Data fetching error: ", er.message);
          setLoading(false);
        });
    }
  };
  useEffect(() => {
    getOrgList();
    getSubUnitList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  EntryLevelKeys({
    save: () => saveData(),
    cancel: () =>
      setOpenModel({
        type: "",
        param: {},
      }),
  });

  console.log("orgId value", form.getFieldValue("orgId")?.key);
  return (
    <>
      <Drawer
        open={isModalOpen}
        onClose={() =>
          setOpenModel({
            type: "",
            param: {},
          })
        }
        placement={placement}
        title={`${id ? "Update" : "Add"} department`}
        width={"500px"}
        closable={false}
        maskClosable={false}
        extra={
          <Space>
            <CloseOutlined
              onClick={() =>
                setOpenModel({
                  type: "",
                  param: {},
                })
              }
            />
          </Space>
        }
        footer={
          <div style={{ textAlign: "right" }}>
            <Space>
              <Tooltip
                title={<p>ALT+C</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  onClick={() => {
                    form.resetFields();
                    setOpenModel({
                      type: "",
                      param: {},
                    });
                  }}
                >
                  Cancel
                </Button>
              </Tooltip>

              <Tooltip
                title={<p>ALT+S</p>}
                placement="bottomLeft"
                open={showKeys}
              >
                <Button
                  disabled={loading}
                  loading={loading}
                  type="primary"
                  onClick={() => saveData()}
                >
                  {`${id ? "Update" : "Save"}`}
                </Button>
              </Tooltip>
            </Space>
          </div>
        }
      >
        <Form name="deptt" form={form} disabled={loading} layout="vertical">
          <Form.Item
            name="depttName"
            label="Department's Name"
            rules={[
              { required: true },
              {
                pattern:
                  /^(?!.* {2})([A-Za-z][A-Za-z0-9_()&\-., ]{1,48}[A-Za-z0-9])$/,
                message: "Value's length must be between 3 and 50",
              },
              {
                validator: () => {
                  if (duplicateData)
                    return Promise.reject("Department Name already exist");
                  else return Promise.resolve();
                },
              },
            ]}
            className="input-item"
          >
            <Input
              type="text"
              maxLength={50}
              minLength={3}
              placeholder="Enter name here..."
              onChange={(e) => handleDuplicates(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="depttType"
            label="Department Type"
            rules={[
              { required: true, message: "Please select department type" },
            ]}
            className="input-item"
          >
            <Select
              placeholder="Select type"
              options={DepartmentTypeList.map(
                (deptt: IDropdownProps<Department_Type>) => ({
                  label: deptt.label,
                  value: deptt.value,
                  key: deptt.key,
                  title: "",
                })
              )}
            />
          </Form.Item>
          <Form.Item
            name="orgId"
            label="Organisation"
            rules={[{ required: true, message: "Please select organisation" }]}
            className="input-item"
          >
            <Select
              labelInValue
              placeholder="Select organisation"
              onChange={(val) => {
                form.setFieldValue("subUnitId", undefined);
                setSelOrg({ id: val?.value!, name: val?.label });
              }}
              options={orgList.map((org: IIdNameModel) => ({
                label: org.name,
                value: org.id,
                key: org.id,
                title: "",
              }))}
              disabled={organisationId ? true : false}
              dropdownRender={(orgList) => (
                <>
                  {orgList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() => {
                      setOpenModelType({
                        type: "Organisation",
                        param: {},
                      });
                    }}
                  >
                    New Organisation
                  </Button>
                </>
              )}
            />
          </Form.Item>
          <Form.Item
            name="subUnitId"
            label="Sub Unit"
            rules={[{ required: true, message: "Please select sub unit" }]}
            className="input-item"
          >
            <Select
              labelInValue
              disabled={selOrg.id === "" || subUnitId !== undefined}
              placeholder="Select sub unit"
              options={subUnitList
                .filter(
                  (subUnit: ISubUnitOptionsList) => subUnit?.orgId === selOrg.id
                )
                .map((subUnit: ISubUnitOptionsList) => ({
                  label: subUnit.name,
                  value: subUnit.id,
                  key: subUnit.id,
                  title: "",
                }))}
              dropdownRender={(subUnitList) => (
                <>
                  {subUnitList}
                  <Divider style={{ margin: "5px 0px" }} />
                  <Button
                    style={{ width: "100%" }}
                    icon={<PlusOutlined />}
                    type="link"
                    onClick={() =>
                      setOpenModelType({
                        type: "SubUnit",
                        param: {},
                      })
                    }
                  >
                    New Sub Unit
                  </Button>
                </>
              )}
            />
          </Form.Item>
        </Form>
      </Drawer>
      {openModelType.type === "Organisation" && (
        <AddOrganisationModel
          isModalOpen={true}
          setOpenModel={setOpenModelType}
          setNewResponse={setNewOrganisationResponse}
          placement={"left"}
        />
      )}
      {openModelType.type === "SubUnit" && (
        <AddSubUnitModel
          isModalOpen={true}
          setOpenModel={setOpenModelType}
          setNewSubUnitResponse={setNewSubUnitResponse}
          placement={"left"}
          organisationId={selOrg.id}
          organisationName={selOrg.name}
        />
      )}
    </>
  );
};

export default AddDepttModel;
